import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import * as Views from './views'
import { GiftSelectionRedirect, GiftStepsLayout } from './components'
import Layout from './Layout'
import { StripePaymentIntentReset } from 'member-portal/components'
import { PATH, makeGiftStepsPath, makePath } from 'config'

const propTypes = {}

function Routes() {
  const { path } = useRouteMatch()

  return (
    <StripePaymentIntentReset>
      <GiftSelectionRedirect>
        <Layout>
          <Switch>
            <Route exact path={makePath(path, PATH.ROOT)}>
              <Views.ProductSelection />
            </Route>
            <Route path={makePath(path, PATH.STEPS)}>
              <GiftStepsLayout>
                <Switch>
                  <Route path={makeGiftStepsPath(PATH.RECIPIENT)}>
                    <Views.Recipient />
                  </Route>
                  <Route path={makeGiftStepsPath(PATH.BILLING)}>
                    <Views.Billing />
                  </Route>
                  <Route path={makeGiftStepsPath(PATH.PAYMENT)}>
                    <Views.PaymentStep />
                  </Route>
                </Switch>
              </GiftStepsLayout>
            </Route>
            <Route path={makePath(path, PATH.CONFIRM_GIFT)}>
              <Views.ConfirmGift />
            </Route>
          </Switch>
        </Layout>
      </GiftSelectionRedirect>
    </StripePaymentIntentReset>
  )
}

Routes.propTypes = propTypes

export default Routes
